import { render } from "./PersonalIntroCard.vue?vue&type=template&id=4ec7face"
import script from "./PersonalIntroCard.vue?vue&type=script&lang=js"
export * from "./PersonalIntroCard.vue?vue&type=script&lang=js"

import "./PersonalIntroCard.vue?vue&type=style&index=0&id=4ec7face&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__